// import Print from "@/api/Print";
// import { useToast } from "vue-toast-notification";
// const toast = useToast();

export const setVerificationImage = ({ commit }, formData) => {
  commit("SET_VERIFICATION_IMAGE", formData);
};

